import { eventBus } from '@/hooks/useEventBus';
import TextOnlyPreview from '../Text/TextOnlyPreview';
import { getScreenElementStyle } from '@/util/canvas';
import { ICanvasElement } from '@/interface/canvas';
import { getHtmlFromString } from '@/util/stringToHtml';
import { getSafeUri } from '@/util/url';

export const ButtonPreview = ({
  element,
  disabled = false,
}: ButtonPreviewProps) => {
  const style = getScreenElementStyle(element);
  const onClick = () => {
    if (element?.event) eventBus.emit(element?.event);
  };
  if (element?.event === 'cta')
    return (
      <a
        target="_blank"
        href={getSafeUri(element?.uri)}
        onClick={e => {
          e.stopPropagation();
          if (!element?.uri) {
            e.preventDefault();
            return;
          }
          element.event && eventBus.emit(element.event);
        }}
        className="text-center cursor-pointer txt-prev flex justify-center items-center ql-snow z-[1] btn-prev"
        rel="noreferrer"
        style={style}
      >
        <div className="quill">
          <div className="ql-container">
            <div
              dangerouslySetInnerHTML={getHtmlFromString(element?.text || '')}
              className="ql-editor"
            />
          </div>
        </div>
      </a>
    );
  return (
    <button
      disabled={disabled}
      className={`z-[2] mt-1 text-center flex cursor-pointer justify-center items-center txt-prev btn-prev ${
        disabled && 'opacity-70'
      }`}
      id={element?.id}
      style={style}
      onClick={onClick}
    >
      <TextOnlyPreview textContent={element?.text || ''} />
    </button>
  );
};
type ButtonPreviewProps = {
  element: ICanvasElement;
  disabled?: boolean;
};
export default ButtonPreview;
